import React, { Component } from "react";
import Navbar from "./Common/Navbar";

export class Contact extends Component {
	render() {
		return (
			<div>
				<Navbar title="Contact" />
				<div className="container">
					<div className="row">
						<div className="col margin rounded bg-purple">
							<div className="container padding ">
								<div className="row">
									<div className="col text-right">
										<h3>Phoenix Management Team</h3>
									</div>
								</div>
								<div className="row">
									<div className="col rounded bg-light-purple">
										If you have any questions or concerns, please speak with a member of the Management Team at dance, or contact us via email at{" "}
										<strong>
											phoenixamateurdancegroup
											{window.innerWidth < 770 ? <br /> : ""}
											@gmail.com
										</strong>
									</div>
								</div>
							</div>
						</div>
						<div className="col margin rounded bg-purple">
							<div className="container padding ">
								<div className="row">
									<div className="col text-right">
										<h3>Website Admin Team</h3>
									</div>
								</div>
								<div className="row">
									<div className="col rounded bg-light-purple">
										If you're experiencing issues with the website, have discovered a bug, or would like to share feedback, please contact the Website Admin Team at{" "}
										<strong>it@phoenixamateurdancegroup.com</strong>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<div className="col margin rounded bg-purple">
							<div className="container padding ">
								<div className="row">
									<div className="col text-right">
										<h3>Data Protection Statement</h3>
									</div>
								</div>
								<div className="row">
									<div className="col rounded bg-light-purple">
										Phoenix Amateur Dance Group and BK Bespoke Software (including any subcontractors) are committed to protecting your data in accordance with UK GDPR
										legislation. A downloadable Privacy Policy will be made available here in the future. In the meantime, you can request a copy from the management
										team. If you have any questions or concerns about how your data is stored, please contact the Website Admin Team.
										<br />
										You can find information about your rights on this and other websites by clicking <a href="https://www.gov.uk/data-protection">here</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Contact;
